@if (locationSetTypeDetail$ | async; as item) {
  <div>
    <form [formGroup]="form">
      <div    class="flex-gap-12vw flex-space-between-center flex-row">
        <label class="mt-4">Locked</label>
        <mat-form-field class="flex-40" >
          <mat-select
            formControlName="locked"
            type="select"
            placeholder="True or False"
            >
            <mat-option [value]="true">
              True
            </mat-option>
            <mat-option [value]="false">
              False
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div    class="flex-gap-12-5vw flex-space-between-center flex-row">
        <label class="mt-4">Name</label>
        <mat-form-field class="flex-40" >
          <input matInput
            formControlName="name"
            type="text"
            placeholder="Name"
            [required]="true"
            >
        </mat-form-field>
      </div>
      <div    class="flex-gap-12vw flex-space-between-center flex-row">
        <label class="mt-4">Weight</label>
        <mat-form-field class="flex-40" >
          <input matInput
            formControlName="weight"
            type="number"
            placeholder="Name"
            >
        </mat-form-field>
      </div>
      <div    class="flex-gap-10vw flex-space-between-center flex-row">
        <label class="mt-4">Description</label>
        <mat-form-field class="flex-40" >
          <textarea matInput
            cdkTextareaAutosize
            cdkAutosizeMinRows="3"
            formControlName="description"
            type="text"
            placeholder="Description"
          ></textarea>
        </mat-form-field>
      </div>
    </form>
    @if (item.dateUpdated || item.updatedBy) {
      <emm-attribute-updated-info
        [lastUpdatedBy]="item.updatedBy"
        [lastUpdatedDate]="item.dateUpdated"
        class="updated-by"
      ></emm-attribute-updated-info>
    }
  </div>
}
